{
  "sync_log_status_alert": {
    "title": "{data_type} sync completed{error_count, plural, =0 {} =1 { with 1 error} other { with # errors}}",
    "description": "{error_count, plural, =0 {Your {data_type} have successfully synchronised from your eCommerce platform to SparkLayer. Your {data_type} information is up to date.} other {We synced your {data_type} to SparkLayer, however some issues were encountered and we recommend fixing them.}}",
    "last_sync": {
      "full": "Full sync: {date_time}",
      "partial": "Partial sync: {date_time}",
      "combined": "Full sync: {full_date_time} — Partial sync: {partial_date_time}"
    },
    "errors": "errors",
    "load_error": {
      "title": "Unable to load synchronisation status",
      "description": "An error occurred while trying to load your synchronisation status. Please try again. If the issue persists, contact support."
    }
  },
  "sync_log_status_in_progress": {
    "title": "Your {data_type} feed is running a full data sync"
  },
  "sync_log_status_failed": {
    "title": "{data_type} sync failed",
    "description": "Your {data_type} feed has encountered a fatal error."
  },
  "sync_log_error_table": {
    "headings": {
      "name": "Name",
      "description": "Description"
    },
    "caption": "Synchronisation errors",
    "load_error": "There was an error loading your synchronisation errors. Please try again."
  }
}
